<template>
  <a-modal
    :title="title"
    :width="600"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="Close"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Signing Status">
          <a-select
            v-decorator="['contractSignFlag', { rules: [{ required: true, message: 'Please select signing status' }] }]"
            placeholder="Please select signing status"
            style="width: 100%">
            <a-select-option value="-5">Pending Report Pending Risk Review</a-select-option>
            <a-select-option value="-3">Pending Report Submission</a-select-option>
            <a-select-option value="-2">Old Version Support</a-select-option>
            <a-select-option value="-1">Pending Risk Review</a-select-option>
            <a-select-option value="0">Contract Pending</a-select-option>
            <a-select-option value="1">Contract Signed</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Signing Validity Period">
          <a-date-picker
            v-decorator="['contractSignExpeditionDate', { rules: [{ required: true, message: 'Please select signing validity period' }] }]"
            placeholder="Please select signing validity period"
            style="width: 100%"
            show-time
            format="YYYY-MM-DD HH:mm:ss"
            valueFormat="YYYY-MM-DD HH:mm:ss"
          />
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import { editInstallmentContractSign } from '@/webpublicapi/order'

export default {
  name: 'TestInstallContractSignModal',
  data () {
    return {
      title: 'Signing Edit',
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
    }
  },
  methods: {
    edit (record) {
      this.form.resetFields()
      this.model = Object.assign({}, record)
      this.visible = true
      this.$nextTick(() => {
        const fieldsValue = {}
        if (this.model.contractSignFlag !== null && this.model.contractSignFlag !== undefined) {
          fieldsValue.contractSignFlag = String(this.model.contractSignFlag)
        }
        if (this.model.contractSignExpeditionDate) {
          fieldsValue.contractSignExpeditionDate = this.model.contractSignExpeditionDate
        }
        this.form.setFieldsValue(fieldsValue)
      })
    },
    handleOk () {
      const that = this
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          const formData = {
            id: this.model.id,
            contractSignFlag: values.contractSignFlag,
            contractSignExpeditionDate: values.contractSignExpeditionDate,
          }
          editInstallmentContractSign(formData).then((res) => {
            if (res.code === 1000) {
              this.$message.success(res.msg)
              this.$emit('ok')
            } else {
              this.$message.warning(res.msg)
            }
          }).finally(() => {
            this.confirmLoading = false
            this.close()
          })
        }
      })
    },
    handleCancel () {
      this.close()
    },
    close () {
      this.$emit('close')
      this.visible = false
    }
  }
}
</script>
